export enum Steps {
  SELECT_DESIGN = "Select Design",
  FLOORPLAN = "Floorplan",
  OPTIONAL_STEP = "Optional Step",
}
